module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.viewType == _vm.VIEW_FORM_DETAIL) ? _c('div', {
    attrs: {
      "id": "formDetail"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.id),
      expression: "formData.id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "hidden",
      "id": "inputId"
    },
    domProps: {
      "value": (_vm.formData.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "q_avatar",
    on: {
      "mouseover": function($event) {
        _vm.showImageControl(true)
      },
      "mouseleave": function($event) {
        _vm.showImageControl(false)
      }
    }
  }, [_c('img', {
    ref: "guestImage",
    staticClass: "img img-responsive",
    attrs: {
      "src": _vm.formData.imageUrl == '' ? (_vm.formData.picture ? _vm.formData.picture : '/static/img/placeholder.png') : '/image/Guest/' + _vm.formData.imageUrl + '?' + Date.now(),
      "border": "1"
    }
  }), _vm._v(" "), _c('div', {
    ref: "imageControl",
    staticClass: "q_form_image_controls"
  }, [_c('span', {
    staticClass: "icon ion-pencil pull-left q_select_file_button",
    attrs: {
      "title": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.$refs.filePicture.click()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon ion-ios-trash-o pull-right q_clear_file_button",
    attrs: {
      "title": "Clear"
    },
    on: {
      "click": function($event) {
        _vm.clearPicture()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "q_hidden_input_file "
  }, [_c('input', {
    ref: "filePicture",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.pictureChange
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.emailAddress),
      expression: "formData.emailAddress"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputEmailAddress",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": (_vm.formData.emailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "emailAddress", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_GENERAL
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_1",
      "data-toggle": "tab",
      "aria-expanded": "true"
    }
  }, [_vm._v("General")])]), _vm._v(" "), (_vm.formData.isMember) ? _c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_MEMBERSHIP
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_2",
      "data-toggle": "tab",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.onClickTabMembership()
      }
    }
  }, [_vm._v("Membership")])]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_CREATE) ? _c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_COMMUNICATION
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_3",
      "data-toggle": "tab",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        _vm.onClickTabCommunication()
      }
    }
  }, [_vm._v("Communication")])]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_CREATE) ? _c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_GROUP
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_4",
      "data-toggle": "tab",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        _vm.onClickTabGroup()
      }
    }
  }, [_vm._v("Group")])]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_CREATE) ? _c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_PROPERTY
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_5",
      "data-toggle": "tab",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        _vm.onClickTabProperty()
      }
    }
  }, [_vm._v("Residence")])]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_CREATE) ? _c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_ACTIVITY
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_6",
      "data-toggle": "tab",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        _vm.onClickTabActivity()
      }
    }
  }, [_vm._v("Activity")])]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_CREATE) ? _c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_DOCUMENT
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_7",
      "data-toggle": "tab",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        _vm.onClickTabDocument()
      }
    }
  }, [_vm._v("Documents")])]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_CREATE) ? _c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_LEAVE
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_8",
      "data-toggle": "tab",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        _vm.onClickTabLeave()
      }
    }
  }, [_vm._v("Leave")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_GENERAL
    },
    attrs: {
      "id": "tab_1"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputFirstName"
    }
  }, [_vm._v("First Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.firstName),
      expression: "formData.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputFirstName",
      "placeholder": "",
      "disabled": _vm.viewMode == _vm.MODE_VIEW ? true : false
    },
    domProps: {
      "value": (_vm.formData.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "firstName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.viewMode != _vm.MODE_CREATE) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputMemberNo"
    }
  }, [_vm._v("Member No")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.memberNo),
      expression: "formData.memberNo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputMemberNo",
      "placeholder": "",
      "disabled": true
    },
    domProps: {
      "value": (_vm.formData.memberNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "memberNo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('div', {
    class: [{
      'icheckbox_flat-green checked': _vm.formData.isMember
    }, {
      'icheckbox_flat-green': !_vm.formData.isMember
    }],
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "aria-checked": "false",
      "aria-disabled": "false"
    }
  }, [_c('input', {
    staticClass: "flat-red",
    staticStyle: {
      "position": "absolute",
      "opacity": "0"
    },
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    on: {
      "click": _vm.onCheckMember
    }
  }), _vm._v(" "), _c('ins', {
    staticClass: "iCheck-helper",
    staticStyle: {
      "position": "absolute",
      "top": "0%",
      "left": "0%",
      "display": "block",
      "width": "100%",
      "height": "100%",
      "margin": "0px",
      "padding": "0px",
      "background": "rgb(255, 255, 255)",
      "border": "0px",
      "opacity": "0"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_CREATE) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputGuestType"
    }
  }, [_vm._v("Guest Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.guestTypeId),
      expression: "formData.guestTypeId"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.viewMode == _vm.MODE_VIEW ? true : false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formData, "guestTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listGuestType), function(row, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": row.id
      }
    }, [_vm._v("\n                                " + _vm._s(row.name) + "\n                              ")])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_CREATE) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputBirthPlace"
    }
  }, [_vm._v("Birthday")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "padding-right": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.birthPlace),
      expression: "formData.birthPlace"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBirthPlace",
      "placeholder": "",
      "disabled": _vm.viewMode == _vm.MODE_VIEW ? true : false
    },
    domProps: {
      "value": (_vm.formData.birthPlace)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "birthPlace", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.showBirthDate) ? _c('datepicker', {
    attrs: {
      "readonly": true,
      "name": "birthDate",
      "value": _vm.formData.birthDate,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'birthDate',
        'disabled': _vm.viewMode == _vm.MODE_VIEW ? true : false
      },
      "input-style": {
        'width': '100%'
      }
    }
  }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_CREATE) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputGender"
    }
  }, [_vm._v("Gender")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.genderId),
      expression: "formData.genderId"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.viewMode == _vm.MODE_VIEW ? true : false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formData, "genderId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listGender), function(row, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": row.id
      }
    }, [_vm._v("\n                                " + _vm._s(row.name) + "\n                              ")])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_CREATE) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputReligion"
    }
  }, [_vm._v("Religion")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.religionId),
      expression: "formData.religionId"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.viewMode == _vm.MODE_VIEW ? true : false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formData, "religionId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listReligion), function(row, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": row.id
      }
    }, [_vm._v("\n                                " + _vm._s(row.name) + "\n                              ")])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_CREATE) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputBloodType"
    }
  }, [_vm._v("Blood Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.bloodTypeId),
      expression: "formData.bloodTypeId"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.viewMode == _vm.MODE_VIEW ? true : false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formData, "bloodTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listBloodType), function(row, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": row.id
      }
    }, [_vm._v("\n                                " + _vm._s(row.name) + "\n                              ")])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_CREATE) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputPosition"
    }
  }, [_vm._v("Position")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.position),
      expression: "formData.position"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputPosition",
      "placeholder": "",
      "disabled": _vm.viewMode == _vm.MODE_VIEW ? true : false
    },
    domProps: {
      "value": (_vm.formData.position)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "position", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputLastName"
    }
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.lastName),
      expression: "formData.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLastName",
      "placeholder": "",
      "disabled": _vm.viewMode == _vm.MODE_VIEW ? true : false
    },
    domProps: {
      "value": (_vm.formData.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "lastName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.viewMode != _vm.MODE_CREATE) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputMaritalStatus"
    }
  }, [_vm._v("Marital Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.maritalStatusId),
      expression: "formData.maritalStatusId"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.viewMode == _vm.MODE_VIEW ? true : false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formData, "maritalStatusId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listMaritalStatus), function(row, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": row.id
      }
    }, [_vm._v("\n                                " + _vm._s(row.name) + "\n                              ")])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_CREATE) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputNPWP"
    }
  }, [_vm._v("NPWP")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.NPWP),
      expression: "formData.NPWP"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputNPWP",
      "placeholder": "",
      "disabled": _vm.viewMode == _vm.MODE_VIEW ? true : false
    },
    domProps: {
      "value": (_vm.formData.NPWP)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "NPWP", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_CREATE) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputKTP"
    }
  }, [_vm._v("KTP")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.KTP),
      expression: "formData.KTP"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputKTP",
      "placeholder": "",
      "disabled": _vm.viewMode == _vm.MODE_VIEW ? true : false
    },
    domProps: {
      "value": (_vm.formData.KTP)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "KTP", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_CREATE) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputSIM"
    }
  }, [_vm._v("SIM")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.SIM),
      expression: "formData.SIM"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSIM",
      "placeholder": "",
      "disabled": _vm.viewMode == _vm.MODE_VIEW ? true : false
    },
    domProps: {
      "value": (_vm.formData.SIM)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "SIM", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_CREATE) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputStatus"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.status),
      expression: "formData.status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formData, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listStatus), function(row, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": row.id
      }
    }, [_vm._v("\n                                " + _vm._s(row.name) + "\n                              ")])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.viewMode == _vm.MODE_CREATE) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Initial Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.password),
      expression: "formData.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputPassword",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "password", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_CREATE) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputAddress1"
    }
  }, [_vm._v("Address 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.address1),
      expression: "formData.address1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAddress1",
      "placeholder": "",
      "disabled": _vm.viewMode == _vm.MODE_VIEW
    },
    domProps: {
      "value": (_vm.formData.address1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "address1", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_CREATE) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputAddress2"
    }
  }, [_vm._v("Address 2")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.address2),
      expression: "formData.address2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAddress2",
      "placeholder": "",
      "disabled": _vm.viewMode == _vm.MODE_VIEW
    },
    domProps: {
      "value": (_vm.formData.address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "address2", $event.target.value)
      }
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_MEMBERSHIP
    },
    attrs: {
      "id": "tab_2"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box no-border"
  }, [_c('div', {
    staticClass: "box-header",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.onCreateMembership
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.onCreateBacklogMembership
    }
  }, [_vm._v("Add Backlog")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.listGuestMembership), function(row, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.startSequence + i + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('a', {
      ref: "displayRowMembership",
      refInFor: true,
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onDisplayMembership(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-search",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Display"
      }
    })]), _vm._v(" "), _c('a', {
      ref: "editRowMembership",
      refInFor: true,
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onEditMembership(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-edit",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Edit"
      }
    })]), _vm._v(" "), _c('a', {
      ref: "deleteRowMembership",
      refInFor: true,
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onDeleteMembership(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-ios-trash",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Delete"
      }
    })]), _vm._v(" "), _c('a', {
      ref: "renewalRowMembership",
      refInFor: true,
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onRenewalMembership(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-repeat",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Renewal"
      }
    })]), _vm._v(" "), _c('a', {
      ref: "approveRowMembership",
      refInFor: true,
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onApproveMembership(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-checkmark",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Approve"
      }
    })]), _vm._v(" "), _c('a', {
      ref: "leaveRowMembership",
      refInFor: true,
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onLeaveMembership(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-ios-pause",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Create Leave"
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.membershipName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(row.joinDate))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(row.validFrom))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(row.validTo))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(row.price))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(row.tax))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(row.discount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(row.amount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(row.currencyName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [(row.status == _vm.MEMBERSHIP_SUBMIT) ? _c('span', {
      staticClass: "badge bg-blue"
    }, [_vm._v(_vm._s(row.status))]) : _vm._e(), _vm._v(" "), (row.status == _vm.MEMBERSHIP_PAID) ? _c('span', {
      staticClass: "badge bg-yellow"
    }, [_vm._v(_vm._s(row.status))]) : _vm._e(), _vm._v(" "), (row.status == _vm.MEMBERSHIP_ACTIVE) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v(_vm._s(row.status))]) : _vm._e(), _vm._v(" "), (row.status == _vm.MEMBERSHIP_EXPIRED) ? _c('span', {
      staticClass: "badge bg-red"
    }, [_vm._v(_vm._s(row.status))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.getPaymentImage(row.id)
        }
      }
    }, [_vm._v(_vm._s(row.attachment))])]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.id))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.guestId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.membershipId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.currencyId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.period))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.freeFlag))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.projectId))])])
  }))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_COMMUNICATION
    },
    attrs: {
      "id": "tab_3"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box no-border"
  }, [_c('div', {
    staticClass: "box-header",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.onCreateCommunication
    }
  }, [_vm._v("Create")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.listGuestCommunication), function(row, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.startSequence + i + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('a', {
      ref: "displayRowCommunication",
      refInFor: true,
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onDisplayCommunication(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-search",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Display"
      }
    })]), _vm._v(" "), _c('a', {
      ref: "editRowCommunication",
      refInFor: true,
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onEditCommunication(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-edit",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Edit"
      }
    })]), _vm._v(" "), _c('a', {
      ref: "deleteRowCommunication",
      refInFor: true,
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onDeleteCommunication(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-ios-trash",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Delete"
      }
    })])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.type))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.contactNo))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.note))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.id))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.guestId))])])
  }))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_GROUP
    },
    attrs: {
      "id": "tab_4"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box no-border"
  }, [_c('div', {
    staticClass: "box-header",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.onCreateGroup
    }
  }, [_vm._v("Create")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.listGuestGroup), function(row, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.startSequence + i + 1))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.groupName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(row.inQuota))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.relationship))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.id))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.guestId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.groupId))])])
  }))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_PROPERTY
    },
    attrs: {
      "id": "tab_5"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box no-border"
  }, [_c('div', {
    staticClass: "box-header",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.onCreateProperty()
      }
    }
  }, [_vm._v("Create")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.listGuestProperty), function(row, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.startSequence + i + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onDisplayProperty(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-search",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Display"
      }
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onEditProperty(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-edit",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Edit"
      }
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onDeleteProperty(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-ios-trash",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Delete"
      }
    })])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.type))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.cluster))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.block))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.number))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.tower))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.floor))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.note))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.id))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.guestId))])])
  }))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_ACTIVITY
    },
    attrs: {
      "id": "tab_6"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box no-border"
  }, [_c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.listGuestActivity), function(row, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.startSequence + i + 1))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.description))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(row.activityDate))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(row.activityTime))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.projectName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.venueName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.status))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.attachment))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.id))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.guestId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.projectId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.venueId))])])
  }))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_DOCUMENT
    },
    attrs: {
      "id": "tab_7"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box no-border"
  }, [_c('div', {
    staticClass: "box-header",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.onCreateDocument
    }
  }, [_vm._v("Create")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.listDocument), function(row, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.startSequence + i + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onDisplayDocument(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-search",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Display"
      }
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onEditDocument(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-edit",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Edit"
      }
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onDeleteDocument(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-ios-trash",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Delete"
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.getDocumentImage(row.id)
        }
      }
    }, [_vm._v(_vm._s(row.imageUrl))])]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.id))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.guestId))])])
  }))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_LEAVE
    },
    attrs: {
      "id": "tab_8"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box no-border"
  }, [_c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.listLeave), function(row, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.startSequence + i + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(row.dateFrom))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(row.dateTo))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.membershipName))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.description))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.id))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.guestId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.membershipId))])])
  }))])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.onBack
    }
  }, [_vm._v("Back")]), _vm._v(" "), (_vm.viewMode != _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.viewMode == _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("Edit")]) : _vm._e()])])])])])])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.viewType == _vm.VIEW_FORM_MEMBERSHIP) ? _c('div', {
    attrs: {
      "id": "formMembership"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataMembership.id),
      expression: "formDataMembership.id"
    }],
    attrs: {
      "type": "hidden",
      "id": "inputMembershipId"
    },
    domProps: {
      "value": (_vm.formDataMembership.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataMembership, "id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataMembership.guestId),
      expression: "formDataMembership.guestId"
    }],
    attrs: {
      "type": "hidden",
      "id": "inputGuestId"
    },
    domProps: {
      "value": (_vm.formDataMembership.guestId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataMembership, "guestId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataMembership.membershipId),
      expression: "formDataMembership.membershipId"
    }],
    attrs: {
      "type": "hidden",
      "id": "inputMembershipId"
    },
    domProps: {
      "value": (_vm.formDataMembership.membershipId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataMembership, "membershipId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataMembership.currencyId),
      expression: "formDataMembership.currencyId"
    }],
    attrs: {
      "type": "hidden",
      "id": "inputCurrencyId"
    },
    domProps: {
      "value": (_vm.formDataMembership.currencyId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataMembership, "currencyId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputMembershipName"
    }
  }, [_vm._v("Membership")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataMembership.membershipName),
      expression: "formDataMembership.membershipName"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": "true",
      "type": "text",
      "id": "inputMembershipName"
    },
    domProps: {
      "value": (_vm.formDataMembership.membershipName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataMembership, "membershipName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-info btn-flat",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#modal-default",
      "disabled": _vm.viewMode == _vm.MODE_VIEW
    },
    on: {
      "click": _vm.onSearchMembership
    }
  }, [_c('i', {
    staticClass: "icon ion-fw fa-search"
  })])])])])]), _vm._v(" "), (_vm.viewIsGroup) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputQuota"
    }
  }, [_vm._v("Quota Group")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataMembership.quota),
      expression: "formDataMembership.quota"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "quota",
      "input-attr": {
        'id': 'quota',
        'disabled': _vm.viewMode == _vm.MODE_VIEW ? true : false
      }
    },
    domProps: {
      "value": (_vm.formDataMembership.quota)
    },
    on: {
      "keyup": function($event) {
        _vm.calculateQuotaGroup($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataMembership, "quota", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputJoinDate"
    }
  }, [_vm._v("Join Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.showJoinDate) ? _c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "readonly": true,
      "name": "joinDate",
      "value": _vm.formDataMembership.joinDate,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'joinDate',
        'disabled': _vm.viewMode == _vm.MODE_VIEW ? true : false
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedJoinDate
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputValidFrom"
    }
  }, [_vm._v("Valid From")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.showValidFrom) ? _c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "readonly": true,
      "name": "validFrom",
      "value": _vm.formDataMembership.validFrom,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'validFrom',
        'disabled': true
      },
      "input-style": {
        'width': '100%'
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputValidTo"
    }
  }, [_vm._v("Valid To")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.showValidTo) ? _c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "readonly": true,
      "name": "validTo",
      "value": _vm.formDataMembership.validTo,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'validTo',
        'disabled': true
      },
      "input-style": {
        'width': '100%'
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputPeriod"
    }
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataMembership.period),
      expression: "formDataMembership.period"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": "true",
      "type": "text",
      "id": "inputPeriod"
    },
    domProps: {
      "value": (_vm.formDataMembership.period)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataMembership, "period", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputPrice"
    }
  }, [_vm._v("Price")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataMembership.price),
      expression: "formDataMembership.price"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": "true",
      "id": "inputPrice",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formDataMembership.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataMembership, "price", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputTax"
    }
  }, [_vm._v("Tax")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataMembership.tax),
      expression: "formDataMembership.tax"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": "true",
      "id": "inputTax",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formDataMembership.tax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataMembership, "tax", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputDiscount"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataMembership.discount),
      expression: "formDataMembership.discount"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": "true",
      "id": "inputDiscount",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formDataMembership.discount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataMembership, "discount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputAmount"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataMembership.amount),
      expression: "formDataMembership.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": "true",
      "id": "inputAmount",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formDataMembership.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataMembership, "amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-offset-1 col-sm-3"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataMembership.freeFlag),
      expression: "formDataMembership.freeFlag"
    }],
    attrs: {
      "readonly": "true",
      "disabled": "true",
      "type": "checkbox",
      "id": "inputFreeFlag"
    },
    domProps: {
      "checked": Array.isArray(_vm.formDataMembership.freeFlag) ? _vm._i(_vm.formDataMembership.freeFlag, null) > -1 : (_vm.formDataMembership.freeFlag)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.formDataMembership.freeFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.formDataMembership, "freeFlag", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.formDataMembership, "freeFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.formDataMembership, "freeFlag", $$c)
        }
      }
    }
  }), _vm._v("Free\n                          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputCurrency"
    }
  }, [_vm._v("Currency")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDataMembership.currencyName),
      expression: "formDataMembership.currencyName"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": "true",
      "id": "inputCurrency",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formDataMembership.currencyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDataMembership, "currencyName", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        _vm.onBackMembership()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.onCancelMembership()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.viewMode != _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.onSaveMembership()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.viewMode == _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.onEditMembership(_vm.formDataMembership)
      }
    }
  }, [_vm._v("Edit")]) : _vm._e()])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.viewType == _vm.VIEW_FORM_COMMUNICATION) ? _c('div', {
    attrs: {
      "id": "formCommunication"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCommunication.id),
      expression: "formCommunication.id"
    }],
    attrs: {
      "type": "hidden",
      "id": "inputCommunicationId"
    },
    domProps: {
      "value": (_vm.formCommunication.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCommunication, "id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCommunication.guestId),
      expression: "formCommunication.guestId"
    }],
    attrs: {
      "type": "hidden",
      "id": "inputGuestId"
    },
    domProps: {
      "value": (_vm.formCommunication.guestId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCommunication, "guestId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputCommunicationType"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCommunication.type),
      expression: "formCommunication.type"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.viewMode == _vm.MODE_VIEW
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formCommunication, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listCommunicationType), function(row, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": row.id
      }
    }, [_vm._v("\n                            " + _vm._s(row.name) + "\n                          ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputContactNo"
    }
  }, [_vm._v("Contact No.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCommunication.contactNo),
      expression: "formCommunication.contactNo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputContactNo"
    },
    domProps: {
      "value": (_vm.formCommunication.contactNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCommunication, "contactNo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputNote"
    }
  }, [_vm._v("Note")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCommunication.note),
      expression: "formCommunication.note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputNote"
    },
    domProps: {
      "value": (_vm.formCommunication.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCommunication, "note", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        _vm.onBackCommunication()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.onCancelCommunication()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.viewMode != _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.onSaveCommunication()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.viewMode == _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.onEditCommunication(_vm.formCommunication)
      }
    }
  }, [_vm._v("Edit")]) : _vm._e()])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.viewType == _vm.VIEW_FORM_PROPERTY) ? _c('div', {
    attrs: {
      "id": "formProperty"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formProperty.id),
      expression: "formProperty.id"
    }],
    attrs: {
      "type": "hidden",
      "id": "inputPropertyId"
    },
    domProps: {
      "value": (_vm.formProperty.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formProperty, "id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formProperty.guestId),
      expression: "formProperty.guestId"
    }],
    attrs: {
      "type": "hidden",
      "id": "inputGuestId"
    },
    domProps: {
      "value": (_vm.formProperty.guestId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formProperty, "guestId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputPropertyType"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formProperty.type),
      expression: "formProperty.type"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.viewMode == _vm.MODE_VIEW
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formProperty, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listPropertyType), function(row, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": row.id
      }
    }, [_vm._v("\n                            " + _vm._s(row.name) + "\n                          ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formProperty.name),
      expression: "formProperty.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputName"
    },
    domProps: {
      "value": (_vm.formProperty.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formProperty, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputCluster"
    }
  }, [_vm._v("Cluster")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formProperty.cluster),
      expression: "formProperty.cluster"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCluster"
    },
    domProps: {
      "value": (_vm.formProperty.cluster)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formProperty, "cluster", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputBlock"
    }
  }, [_vm._v("Block/No.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formProperty.block),
      expression: "formProperty.block"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBlock"
    },
    domProps: {
      "value": (_vm.formProperty.block)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formProperty, "block", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputNumber"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formProperty.number),
      expression: "formProperty.number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputNumber"
    },
    domProps: {
      "value": (_vm.formProperty.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formProperty, "number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputTower"
    }
  }, [_vm._v("Tower")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formProperty.tower),
      expression: "formProperty.tower"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputTower"
    },
    domProps: {
      "value": (_vm.formProperty.tower)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formProperty, "tower", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputFloor"
    }
  }, [_vm._v("Floor")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formProperty.floor),
      expression: "formProperty.floor"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputFloor"
    },
    domProps: {
      "value": (_vm.formProperty.floor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formProperty, "floor", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputNote"
    }
  }, [_vm._v("Note")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formProperty.note),
      expression: "formProperty.note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputNote"
    },
    domProps: {
      "value": (_vm.formProperty.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formProperty, "note", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        _vm.onBackProperty()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.onCancelProperty()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.viewMode != _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.onSaveProperty()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.viewMode == _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.onEditProperty(_vm.formProperty)
      }
    }
  }, [_vm._v("Edit")]) : _vm._e()])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.viewType == _vm.VIEW_FORM_DOCUMENT) ? _c('div', {
    attrs: {
      "id": "formDocument"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDocument.id),
      expression: "formDocument.id"
    }],
    attrs: {
      "type": "hidden",
      "id": "inputDocumentId"
    },
    domProps: {
      "value": (_vm.formDocument.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDocument, "id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDocument.guestId),
      expression: "formDocument.guestId"
    }],
    attrs: {
      "type": "hidden",
      "id": "inputGuestId"
    },
    domProps: {
      "value": (_vm.formDocument.guestId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDocument, "guestId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDocument.name),
      expression: "formDocument.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputName",
      "disabled": _vm.viewMode != _vm.MODE_CREATE
    },
    domProps: {
      "value": (_vm.formDocument.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDocument, "name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "q_avatar",
    on: {
      "mouseover": function($event) {
        _vm.showImageDocumentControl(true)
      },
      "mouseleave": function($event) {
        _vm.showImageDocumentControl(false)
      }
    }
  }, [_c('img', {
    ref: "guestDocumentImage",
    staticClass: "img img-responsive",
    attrs: {
      "src": _vm.formDocument.imageUrl == '' ? (_vm.formDocument.picture ? _vm.formDocument.picture : '/static/img/placeholder.png') : '/image/Guest/GuestDocument/' + _vm.formDocument.imageUrl + '?' + Date.now(),
      "border": "1"
    }
  }), _vm._v(" "), _c('div', {
    ref: "imageDocumentControl",
    staticClass: "q_form_image_controls"
  }, [_c('span', {
    staticClass: "icon ion-pencil pull-left q_select_file_button",
    attrs: {
      "title": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.$refs.filePictureDocument.click()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon ion-ios-trash-o pull-right q_clear_file_button",
    attrs: {
      "title": "Clear"
    },
    on: {
      "click": function($event) {
        _vm.clearPictureDocument()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "q_hidden_input_file "
  }, [_c('input', {
    ref: "filePictureDocument",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.pictureChangeDocument
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        _vm.onBackDocument()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.onCancelDocument()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.viewMode != _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.onSaveDocument()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.viewMode == _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.onEditDocument(_vm.formDocument)
      }
    }
  }, [_vm._v("Edit")]) : _vm._e()])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.viewType == _vm.VIEW_FORM_GROUP) ? _c('div', {
    attrs: {
      "id": "formGroup"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formGuestGroup.id),
      expression: "formGuestGroup.id"
    }],
    attrs: {
      "type": "hidden",
      "id": "inputGrouptId"
    },
    domProps: {
      "value": (_vm.formGuestGroup.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formGuestGroup, "id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formGuestGroup.guestId),
      expression: "formGuestGroup.guestId"
    }],
    attrs: {
      "type": "hidden",
      "id": "inputGuestId"
    },
    domProps: {
      "value": (_vm.formGuestGroup.guestId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formGuestGroup, "guestId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name),
      expression: "formData.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputName",
      "placeholder": "Group Name"
    },
    domProps: {
      "value": (_vm.formData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_GENERAL
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_1",
      "data-toggle": "tab",
      "aria-expanded": "true"
    }
  }, [_vm._v("General")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_GUESTGROUP
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_2",
      "data-toggle": "tab",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        _vm.onClickTabGuestGroup()
      }
    }
  }, [_vm._v("Guest of Group")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_GENERAL
    },
    attrs: {
      "id": "tab_1"
    }
  }, [_c('div', {
    staticClass: "box no-border form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputProductType"
    }
  }, [_vm._v("Group Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.type),
      expression: "formData.type"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.viewMode == _vm.MODE_VIEW
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formData, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listGroupType), function(row, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": row.id
      }
    }, [_vm._v("\n                                      " + _vm._s(row.name) + "\n                                    ")])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputQuota"
    }
  }, [_vm._v("Quota")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.quota),
      expression: "formData.quota"
    }],
    ref: "inputQuota",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputQuota",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.quota)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "quota", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputCompany"
    }
  }, [_vm._v("Company")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.company),
      expression: "formData.company"
    }],
    ref: "inputCompany",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputCompany",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "company", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputMainGuest"
    }
  }, [_vm._v("Main Guest")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.mainGuestName),
      expression: "formData.mainGuestName"
    }],
    ref: "inputMainGuest",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputMainGuest",
      "list": "listMainGuest",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.mainGuestName)
    },
    on: {
      "change": function($event) {
        _vm.onGetMainGuest($event)
      },
      "keyup": function($event) {
        _vm.onSearchMainGuest($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "mainGuestName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('datalist', {
    attrs: {
      "id": "listMainGuest"
    }
  }, _vm._l((_vm.listGuest), function(row, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": row.firstName + ' ' + row.lastName
      }
    })
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputNPWP"
    }
  }, [_vm._v("NPWP")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.npwp),
      expression: "formData.npwp"
    }],
    ref: "inputNPWP",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputNPWP",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.npwp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "npwp", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputAddress1"
    }
  }, [_vm._v("Address 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.address1),
      expression: "formData.address1"
    }],
    ref: "inputAddress1",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputAddress1",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.address1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "address1", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputAddress2"
    }
  }, [_vm._v("Address 2")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.address2),
      expression: "formData.address2"
    }],
    ref: "inputAddress2",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputAddress2",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "address2", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_GUESTGROUP
    },
    attrs: {
      "id": "tab_2"
    }
  }, [_c('div', {
    staticClass: "box no-border"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modal-addGuest"
    }
  }, [_vm._v("Add Guest")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px",
      "text-align": "right"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Guest")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("In Quota")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Relationship")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listGuestGroup), function(row, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticStyle: {
        "width": "45px",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.startSequence + i + 1))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "85px",
        "text-align": "center"
      }
    }, [_c('a', {
      ref: "displayRow",
      refInFor: true,
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onDisplayGuestGroup(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-search",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Display"
      }
    })]), _vm._v(" "), _c('a', {
      ref: "editRow",
      refInFor: true,
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onEditGuestGroup(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-edit",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Edit"
      }
    })]), _vm._v(" "), _c('a', {
      ref: "deleteRow",
      refInFor: true,
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onDeleteGuestGroup(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-ios-trash",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Delete"
      }
    })])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.guestName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(row.inQuota))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.relationship))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.id))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.guestId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.groupId))])])
  }))])])])])])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.id),
      expression: "formData.id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "hidden",
      "id": "inputId"
    },
    domProps: {
      "value": (_vm.formData.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.mainGuestId),
      expression: "formData.mainGuestId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "hidden",
      "id": "inputMainGuestId"
    },
    domProps: {
      "value": (_vm.formData.mainGuestId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "mainGuestId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        _vm.onBack()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.onCancel()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.viewMode != _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.onSave()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.viewMode == _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.onEdit(_vm.formData)
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.viewMode == _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        _vm.onCreate()
      }
    }
  }, [_vm._v("Create")]) : _vm._e()])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "modal-default"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "box no-border"
  }, [_c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.listMembership), function(row, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.startSequence + i + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('input', {
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.onChooseMembershipItem(row, $event)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.projectName))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(row.validFrom))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(row.validTo))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(row.price))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(row.tax))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(row.discount))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(row.currencyName))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.period))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(row.freeFlag))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.id))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.projectId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.typeId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.categoryId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.currencyId))])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "btnCloseModal",
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onChooseMembership($event)
      }
    }
  }, [_vm._v("Choose")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "modal-create-leave"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "box-body no-border form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Guest")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formLeave.guestName),
      expression: "formLeave.guestName"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formLeave.guestName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formLeave, "guestName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formLeave.guestId),
      expression: "formLeave.guestId"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.formLeave.guestId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formLeave, "guestId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Membership")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formLeave.membershipName),
      expression: "formLeave.membershipName"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formLeave.membershipName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formLeave, "membershipName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formLeave.membershipId),
      expression: "formLeave.membershipId"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.formLeave.membershipId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formLeave, "membershipId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Date From")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.showDateFrom) ? _c('datepicker', {
    attrs: {
      "value": _vm.formLeave.dateFrom,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'dateFrom'
      },
      "input-style": {
        'width': '100%'
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Date To")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.showDateTo) ? _c('datepicker', {
    attrs: {
      "value": _vm.formLeave.dateTo,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'dateTo'
      },
      "input-style": {
        'width': '100%'
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formLeave.description),
      expression: "formLeave.description"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formLeave.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formLeave, "description", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "btnCloseModal",
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.onContinueCreateLeave($event)
      }
    }
  }, [_vm._v("Continue")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px",
      "text-align": "right"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Membership")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Join Date")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Valid From")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Valid To")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Price")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Tax")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Currency")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Attachment")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px",
      "text-align": "right"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Contact No.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Note")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px",
      "text-align": "right"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Group")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("In Quota")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Relationship")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px",
      "text-align": "right"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Cluster")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Block")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Unit No.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Tower")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Floor")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Note")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px",
      "text-align": "right"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Activity Date")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Activity Time")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Project")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Venue")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Attachment")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px",
      "text-align": "right"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Document")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px",
      "text-align": "right"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Date From")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Date To")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Membership Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("List of Membership")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "width": "10px",
      "text-align": "right"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Membership")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Project")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Valid From")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Valid To")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Price")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Tax")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Currency")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Period")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Free")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Create Leave")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18911e36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/GuestForm.vue
// module id = 713
// module chunks = 1